import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { CategoryApi } from "@/config/apiClient";
import { createApiClient } from "@/config/createApiClient";
import { currentWorkspaceAtom } from "@/store";

const apiClient = createApiClient(CategoryApi);

export const useCategories = () => {
  const currentWorkspace = useAtomValue(currentWorkspaceAtom);

  const useGetServiceCategories = () =>
    useQuery({
      staleTime: 30 * 60 * 1000,
      queryKey: [
        "serviceCategories",
        currentWorkspace?.accountId,
        currentWorkspace?.organizationId,
        currentWorkspace?.id,
      ],
      enabled: !!currentWorkspace,
      queryFn: () => {
        return apiClient.categoriesControllerGetWorkspaceCategories({
          accountId: currentWorkspace?.accountId,
          organizationId: currentWorkspace?.organizationId,
          workspaceId: currentWorkspace?.id,
        });
      },
    });

  return { useGetServiceCategories };
};
